export enum HintsConfigType {
  CARE_PLAN = 'CARE_PLAN',
  DECUBITUS_RISK = 'DECUBITUS_RISK',
  FALL_RISK = 'FALL_RISK',
  MOVEMENT_STATUS = 'MOVEMENT_STATUS',
  CONSULTATION = 'CONSULTATION',
  PAIN_PROTOCOL = 'PAIN_PROTOCOL',
  HOSPITAL_EXPORT = 'HOSPITAL_EXPORT',
  NURSE_VISIT = 'NURSE_VISIT',
}
